<template>
  <div class="table-responsive">
    <div class="modal fade" id="cardModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" style="color: black">
            <h5 class="modal-title">Create card of ticket</h5>
          </div>
          {{ getUser }}
          <div class="modal-body" style="height: 400px; max-height: 400px">
            <div class="col-md-12">
              <div class="form-group">
                <label>Select board list:</label>
                <select v-model="ticketForm.list_id" class="form-control" style="padding: 5px 10px"
                  placeholder="Select list">
                  <option v-for="list in board_lists" :value="list.id">
                    {{ list.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <label class="label-form" for="message">Card Title:</label>
              <input v-model="ticketForm.list_card_title" class="form-control" type="text" />
            </div>
            <div class="col-md-12">
              <label class="label-form" for="message">Card Description:</label>
              <textarea v-model="ticketForm.list_card_desc" class="form-control" type="text" rows="6"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" id="close">
              Close
            </button>
            <button type="button" class="btn btn-primary" @click="saveCard()">
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
    <div  v-if="isLoader && mobile_screen"  >
      <div class="loader_responsive">
        <b-skeleton-wrapper >
          <div style="display:flex; flex-direction:row">
            <b-col cols="4" height="120px" style="background-color: #e7eef3 !important;height:33px"></b-col>
            <b-col cols="3" height="120px" style="margin-left:4%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="2" height="120px" style="margin-left:2%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="2" height="120px" style="margin-left:1%; background-color: #e7eef3 !important;height:33px"></b-col>
          </div>
          <div style="display:flex; flex-direction:row">
            <b-col cols="3" height="120px" style="margin-top:4px; margin-bottom:4px; background-color: #e7eef3 !important;height:33px"></b-col>
            <b-col cols="3" height="120px" style="margin-top:4px; margin-bottom:4px;  margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="3" height="120px" style="margin-top:4px; margin-bottom:4px; margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="2" height="120px" style="margin-top:4px; margin-bottom:4px;  margin-left:2%; background-color: #e7eef3 !important;height:33px"></b-col>
          </div>                                  
        </b-skeleton-wrapper> 
      </div>
      <div class="loader_responsive mt-2">
        <b-skeleton-wrapper >
          <div style="display:flex; flex-direction:row">
            <b-col cols="4" height="120px" style="background-color: #e7eef3 !important;height:33px"></b-col>
            <b-col cols="3" height="120px" style="margin-left:4%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="2" height="120px" style="margin-left:2%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="2" height="120px" style="margin-left:1%; background-color: #e7eef3 !important;height:33px"></b-col>
          </div>
          <div style="display:flex; flex-direction:row">
            <b-col cols="3" height="120px" style="margin-top:4px; margin-bottom:4px; background-color: #e7eef3 !important;height:33px"></b-col>
            <b-col cols="3" height="120px" style="margin-top:4px; margin-bottom:4px;  margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="3" height="120px" style="margin-top:4px; margin-bottom:4px; margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="2" height="120px" style="margin-top:4px; margin-bottom:4px;  margin-left:2%; background-color: #e7eef3 !important;height:33px"></b-col>
          </div>                                  
        </b-skeleton-wrapper> 
      </div>
      <div class="loader_responsive mt-2">
        <b-skeleton-wrapper >
          <div style="display:flex; flex-direction:row">
            <b-col cols="4" height="120px" style="background-color: #e7eef3 !important;height:33px"></b-col>
            <b-col cols="3" height="120px" style="margin-left:4%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="2" height="120px" style="margin-left:2%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="2" height="120px" style="margin-left:1%; background-color: #e7eef3 !important;height:33px"></b-col>
          </div>
          <div style="display:flex; flex-direction:row">
            <b-col cols="3" height="120px" style="margin-top:4px; margin-bottom:4px; background-color: #e7eef3 !important;height:33px"></b-col>
            <b-col cols="3" height="120px" style="margin-top:4px; margin-bottom:4px;  margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="3" height="120px" style="margin-top:4px; margin-bottom:4px; margin-left:3%; background-color: #e7eef3 !important;height:33px;"></b-col>
            <b-col cols="2" height="120px" style="margin-top:4px; margin-bottom:4px;  margin-left:2%; background-color: #e7eef3 !important;height:33px"></b-col>
          </div>                                  
        </b-skeleton-wrapper> 
      </div>
    </div>
    <table class="table table-hover" id="dataTable" width="100%" cellspacing="0">
      <thead id="support_table_header">
        <tr>
          <th>Organization</th>
          <th>Title</th>
          <th>Category</th>
          <th>Generated On</th>
          <th>Last Modified On</th>
          <th>Delivery Date</th>
          <th>Notes</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody id="table_body">
        <tr  v-if="isLoader && !mobile_screen" id="table_row" >
          <td colspan="12">
            <b-skeleton-wrapper >
                <b-skeleton height="40px" ></b-skeleton>   
                <b-skeleton height="40px"></b-skeleton>  
                <b-skeleton height="40px"></b-skeleton>                                     
            </b-skeleton-wrapper> 
          </td>
        </tr>

        <tr v-show="!isLoader" v-for="(ticket, key) in tickets" :demo="ticket" :key="ticket.id"
          v-bind:class="{ highlighted_row: ticket.unread >= 1 }" id="table_row">
<!--          {{ticket}}-->
          <td >
            <span id="td_span">Organization </span>
            <p>{{ ticket.organization_name }}</p>
          </td>
          <td >
            <span id="td_span">Title</span>
            <div>
              <i v-if="mobile_screen && ticket.title.length > 16"  :id="'title'+ticket.id" class="fa fa-info-circle tooltip_color float-right" data-html="true" data-toggle="m-tooltip" data-placment="right" title="" ></i>
              <p :id="'title'+ticket.id">{{ ticket.title }} </p>
              <b-tooltip  v-if="mobile_screen && ticket.title.length > 16" :target="'title'+ticket.id" placement="bottom" style=""> 
              {{ ticket.title }}
              </b-tooltip>
            </div>
            
          </td>
          <td>
            <span id="td_span">Category</span>
            <div>
              <i v-if="mobile_screen && category[ticket.category].length > 12"  :id="'category'+ticket.id" class="fa fa-info-circle tooltip_color float-right" data-html="true" data-toggle="m-tooltip" data-placment="right" title="" ></i>
              <p>{{  category[ticket.category]  }}</p>
              <b-tooltip  :target="'category'+ticket.id" placement="bottom" style=""> 
              {{ category[ticket.category] }}
              </b-tooltip>
            </div>
            
          </td>
          <td>
            <span id="td_span">Generated On</span>
            <p>{{   ticket.created_at  }}</p>
          </td>
          <td>
            <span id="td_span">Last Modified</span>
            <p>{{   ticket.last_modified_on  }}</p>
          </td>
          <td>
            <span id="td_span">Delivery Date</span>
           <p v-if="ticket.delivery_date || ticket.delivery_time">
        {{ ticket.delivery_date }}<span v-if="ticket.delivery_time"> {{ ticket.delivery_time }}</span>
         </p>
          </td>
          <td style="cursor: pointer;" @click="addCommnetToSupport"  :data-id="ticket.id" :data-status="3" :data-organization="ticket.organization_name" :data-title="ticket.title" :data-user="ticket.user_id">
            <span id="td_span" >Comments</span>
            <p class="text-start"> {{ticket.comment_count}}</p>
          </td>

          <!-- Status -->
          <td>
            <div id="responsive_status" style="display:none;">
              <span class="badge " v-if="ticket.status == 0">OPEN</span>
              <span class="badge" v-else-if="ticket.status == 1">IN PROGRESS</span>
              <span class="badge" v-else-if="ticket.status == 3">IN DEVELOPMENT</span>
              <span class="badge" v-else-if="ticket.status == 10">CLOSED</span>
            </div>
            <div id="status" >
              <span v-if="ticket.status == 0" >Open</span>
              <span v-else-if="ticket.status == 1" >In Progress</span>
              <span v-else-if="ticket.status == 3" >In Development</span>
              <span v-else-if="ticket.status == 10" >Closed</span>
            </div>
          </td>
          <td>
            <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
              <span class="fas fa-ellipsis-v" id="action_button" ></span>
            </a>
            <ul class="dropdown-menu style-action hide-menu">
              <template>
                <!-- <router-link :to="
                    '/support/ticket/' +
                    ticket.id +
                    '/' +
                    ticket.organization_id
                  " class="dropdown-item">View</router-link> -->
                <a class="dropdown-item" v-if="$can('all_tickets_view')" @click="viewTicket(ticket.id ,ticket.organization_id)">View</a>
                <a class="dropdown-item text-danger" v-if="$can('all_tickets_delete')" @click="deleteTicket(ticket)">Delete</a>
                <a class="dropdown-item" v-if="$can('all_tickets_move_trello') && ticket.trello_list_id == null && ticket.status != 10"
                  @click="addToTrello(ticket.id, key)">Move To Trello</a>
                <a class="dropdown-item" v-if="ticket.task_id == null && $can('add_task')"
                  @click="developmentStatus" :data-id="ticket.id" :data-status="3" :data-organization="ticket.organization_name" :data-title="ticket.title" :data-time="ticket.delivery_time" :data-date="ticket.delivery_date">Move To Development</a>
               <!-- add organization -->
               <a class="dropdown-item" v-if="$can('all_tickets_move_trello')"
                  @click="assignSuppotTicketOrg"  :data-id="ticket.id" :data-status="3" :data-organization="ticket.organization_name" :data-title="ticket.title" :data-user="ticket.user_id">Assign Organization & User</a>
               <!-- end code add organization -->
             <a class="dropdown-item" v-if="$can('all_tickets_move_trello')"
                  @click="addCommnetToSupport"  :data-id="ticket.id" :data-status="3" :data-organization="ticket.organization_name" :data-title="ticket.title" :data-user="ticket.user_id">Notes</a>
                <a class="dropdown-item"
                   @click="deliveryDate"
                   :data-id="ticket.id"
                   :data-date="ticket.delivery_date"
                   :data-time="ticket.delivery_time"
                >Set Delivery Date</a>
                <a class="dropdown-item"
                   v-if="ticket.status != 10"
                   @click="changeTicketStatus"
                   :data-id="ticket.id"
                   :data-name="ticket.title"
                   :data-status="ticket.status"
                >Change Status</a>
               <!-- end code add organization -->

                <div id="responsiveStatus"  v-if="ticket.status == 1">
                  <hr >  
                  <p id="statusHeading">STATUS<p>
                  <p class="dropdown-item" :style= "[ticket.status == 1 ? {'color':'#457da9 !important'} : {'color':'#212529 !important','font-weight':'500'}]" :value="1" :data-mblscreen="1" :data-id="ticket.id">Inprogress</p>
                  <p class="dropdown-item" :style= "[ticket.status == 10 ? {'color':'#457da9 !important'} : {'color':'#212529 !important','font-weight':'500'}]" :value="10" :data-mblscreen="1" :data-id="ticket.id" @click="changeTicketStatus">Closed</p>
                </div>

              </template>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <h5 style="text-align: center" v-if="tickets.length < 1 && !isLoader">No data found.</h5>
    <div  v-if="!isLoader" class="container border-top"  id="font_size" style="font-size: 14px; bottom: 0">
      <div class="row mt-1 justify-content-end d-flex align-items-center px-3">
        <div class="pt-0 display_rows">
              <span class="pr-3">Total Support Tickets</span>
              <span class="pr-5 color-default text-decoration-underline font-weight-bold
                ">{{total_tickets}}</span>
              <span class="pr-3">Display Rows</span><span class="pr-5 mr-3 color-default font-weight-bold text-decoration-underline">{{displayed_tickets}} </span>

            </div>
        <paginate v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
          :first-button-text="''" :last-button-text="''" :first-last-button="true"
          :container-class="'pagination pagination-sm float-right mt-3 mr-3'" :page-class="'page-item'"
          :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
          :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
      <div v-if="totalPages>0" class="change_page float-right" style="display :none;">
        <a href="#" @click="previousPage" class="previous">&laquo; Previous</a>
        <a href="#" @click="nextPage" class="next">Next &raquo;</a>
      </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from "axios";
  import moment from "moment";
  import taskForm from "../common/development/task/form.vue";

  // import noteForm from "./note_form";
  import supportComment from "./support_comment";
  import quickView from "@/components/support/set_delivery_date.vue";
  import changeStatusComponent from "@/components/support/set_ticket_status.vue";
  export default {
    
    props: ["ticket", "tickets", "totalPages", "page", "setStatus","total_tickets","displayed_tickets","total_tickets_perpage","setskeletonLoader"],
    data: function () {
      return {
        board_lists: [],
        selected_ticket_key: "",
        ticketForm: {
          ticket_id: "",
          list_id: "",
          list_card_title: "",
          list_card_desc: "",
        },
        category: [
          "General Question",
          "Customization or New Feature Request",
          "Bug/System Error Report",
          "System Improvement Suggestion",
          "Request a call back",
          "Request a zoom meeting",
        ],
        mobile_screen: false,
        isLoader: true,
        tpm: [],
      };
    },
   
    computed: {
      currentPage: {
        get: function () {
          return this.page;
        },
        set: function () { },
      },
      showskLoader:function(){
        this.isLoader = this.setskeletonLoader;
        return this.setskeletonLoader;
      },
      getUser(){
      this.$store.dispatch('users/assignToUser');

      }

    },
    watch:{
      showskLoader(){
        this.isLoader = this.setskeletonLoader;
        return this.setskeletonLoader;
      }
     } ,
    created: function () {
      this.getlist();
      this.getProjectManagerList();
      if($( window ).width() > 319 && $( window ).width()< 681){
        this.mobile_screen = true;
      }else{
         this.mobile_screen = false;
      }

    },
    mounted:function(){
      this.isLoader = this.setskeletonLoader;
    },
    methods: {
      viewTicket(id,org_id)
      {
        if(!org_id){
        this.$toast.error(`Please Assign Organization & User First`);
        return false;
        }
        this.$store.dispatch("support/viewticket", { id, org_id });
        const url = '/support/ticket/' + id + '/' + org_id;
        window.open(this.$router.resolve({ path: url }).href, '_blank');

      },
      empty(str) {
        return !str || !/[^\s]+/.test(str);
      },
      saveCard() {
        if (
          this.empty(this.ticketForm.list_card_title) ||
          this.ticketForm.list_id == "" ||
          this.empty(this.ticketForm.list_card_desc)
        ) {
          this.$store.dispatch(
            "message/update",
            {
              title: "Alert",
              body: `Field can not be empty.`,
              class: "warning",
              confirm: false,
            },
            { root: true }
          );
          return;
        }
        this.showskLoader= true;
        this.$store
          .dispatch("support/addCard", this.ticketForm)
          .then((val) => {
            // send successful message
             this.showskLoader= false;
            this.$store.dispatch(
              "message/update",
              {
                title: this.formHeader,
                body: `Card has been added successfully`,
                class: "success",
                confirm: false,
              },
              { root: true }
            );
            $("#close").click();
            if (this.tickets[this.selected_ticket_key]) {
              this.tickets[this.selected_ticket_key].trello_list_id =
                val.data.data.idList;
            }
          })
          .catch((error) => {
            let response = error.response;
             this.showskLoader= false;
            // send error message
            this.$store.dispatch(
              "message/update",
              {
                title: this.formHeader,
                body: response.data.message,
                itemsErrors: response.data.errors,
                class: "danger",
                confirm: false,
              },
              { root: true }
            );
          });
      },
      addToTrello(id, key) {
        this.ticketForm = {
          ticket_id: "",
          list_id: "",
          list_card_title: "",
          list_card_desc: "",
        };
        this.ticketForm.ticket_id = id;
        this.selected_ticket_key = key;
        $("#cardModal").modal();
      },
      getProjectManagerList(){
        this.$store.dispatch("users/getUserList",['project_manager'])
        .then((res) => {
          this.tpm= res;
        });
      },
      getlist() {
        var url = "/support/get-board-list";
        axios
          .post(url, {
            _method: "GET",
          })
          .then((response) => {
            this.board_lists = response.data.data;
          });
      },
      setPage(page) {
        this.$emit("setPage", page);
      },

      deleteTicket(ticket) {
        this.$store.dispatch("message/update", {
          title: ticket.title,
          body: "Are you sure you want to delete this Ticket?",
          class: "danger",
          confirm: true,
        });

        this.$bus.$off("proceed");
        this.$bus.$once("proceed", () => {
          this.delete(ticket);
          this.$store.dispatch("message/close");
        });
      },

      delete(ticket) {
         this.showskLoader= true;
        this.$store
          .dispatch("support/deleteTicket", ticket)
          .then((message) => {
            this.showskLoader= false;
             this.$toast.success(message);
            // send successful message
            // this.$store.dispatch(
            //   "message/update",
            //   {
            //     title: ticket.title,
            //     body: message,
            //     class: "success",
            //     confirm: false,
            //   },
            //   { root: true }
            // );
            this.$gate.setUnreadTicketsCount();
          })
          .catch((error) => {
            // send error message
            false
            this.$store.dispatch(
              "message/update",
              {
                title: ticket.title,
                class: "danger",
                body: error.response.data.message,
                errors: error.response.data.errors,
                confirm: false,
              },
              { root: true }
            );
          });
      },
      developmentStatus(event){
        let ticket_info = event.target.dataset;
        this.$store.dispatch("modal/taskModal", {
            action: "add_task_from_Support_ticket",
            title: "Create Task From Support Ticket",
            formData: {
              ticket_time: moment(ticket_info.time, "HH:mm:ss").format("HH:mm"), 
              ticket_date: moment(ticket_info.date, "MMM DD, YYYY").format("YYYY-MM-DD"),
              ticket_current_status: this.setStatus,
              ticket_id:ticket_info.id,
              ticket_status:ticket_info.status,
              ticket_title:ticket_info.title,
              organization:ticket_info.organization,
            },
            component: taskForm });
      },
      assignSuppotTicketOrg(event){
        let ticket_info = event.target.dataset;
        this.$store.dispatch("modal/taskModal", {
            action: "add_organization_for_support_ticket",
            title: "Update Organization",
            formData: {
              ticket_current_status: this.setStatus,
              ticket_id:ticket_info.id,
              page : this.page,
              ticket_status:ticket_info.status,
              ticket_title:ticket_info.title,
              organization:ticket_info.organization,
              user_id:ticket_info.user,

            },
            component: taskForm 
          });
      },
      addCommnetToSupport(event){
          let ticket_info = event.currentTarget.dataset;
          this.$store.dispatch("modal/update", {
              action: "add_comment_for_support_ticket",
              title: 'Title: '+ticket_info.title,
              formData: {
                ticket_id:ticket_info.id,
                page : this.page,
                ticket_status:ticket_info.status,
                ticket_title:ticket_info.title,
                organization:ticket_info.organization,
                user_id:ticket_info.user,
                ticket_current_status: this.setStatus,

              },
              component: supportComment,
            });
       },

      nextPage(){
        if(this.page+1 <=  this.totalPages){
          this.page++;
            this.$emit("setPage", this.page);
        }
      },
      previousPage(){
        if(this.page-1 != 0){
          this.page--;
            this.$emit("setPage", this.page);
        }
      },

      deliveryDate(event) {
          this.$store.dispatch("modal/setStmDeliveryDate", {
            title: "Set Delivery Date",
            action: "update",
            formData: {
              id: event.target.dataset.id,
              deliveryDate: event.target.dataset.date,
              deliveryTime: event.target.dataset.time,
              currentPage: this.currentPage
            },
            component: quickView,
          });
      },

      changeTicketStatus(event) {
        this.$store.dispatch("modal/setStmDeliveryDate", {
          title: event.target.dataset.name,
          action: "update",
          formData: {
            ticket_id: event.target.dataset.id,
            ticket_status: event.target.dataset.status
          },
          component: changeStatusComponent,
        });
      },
    },
  };
</script>
<style >
  .tooltip{
    border: 0px solid black !important;
  }
  .tooltip .tooltip-inner {
    max-width: 200px !important;
    padding: 0.25rem 0.5rem !important;
    color: #000000de !important;
    text-align: center !important;
    background-color: #dbddde !important;
    border-radius: 0.25rem !important;
    font-size: 12px !important;
    font-weight: 500 !important;
  }
  /* .multiselect__element .multiselect__option--highlight {
    background: #48a6a6 !important;
  }
  .multiselect__option.multiselect__option--highlight.multiselect__option--selected:after{
    background: #e7eef3 !important;
    color:black !important;
  }
  .multiselect__option--highlight:after{
    background: #e7eef3 !important;
    color:black !important;
  }
  .multiselect__option.multiselect__option--highlight.multiselect__option--selected{
      background: #3776a9 !important;
         /* color: #FFFFFF; */
  /* }  */
</style>
<style scoped>  
  .tooltip_color {
          color:#505ed4;
      }
  #td_span,#responsiveStatus{
    display: none !important;
  }
  td > p{
    margin-bottom: 0rem !important;
  }
  table tr td:nth-child(1) {
    width: 14% !important;
  }

  table tr td:nth-child(2) {
    width: 10% !important;
  }

  table tr td:nth-child(3) {
    width: 14% !important;
  }

  table tr td:nth-child(4) {
    width: 9% !important;
  }

  table tr td:nth-child(5) {
    width: 9% !important;
  }

  table tr td:nth-child(6) {
    width: 9% !important;
  }

  table tr td:nth-child(7) {
    width: 10% !important;
  }

  table tr td:nth-child(8) {
    width: 10% !important;
  }
  table tr td:nth-child(9) {
    width: 10% !important;
  }
  table tr td:nth-child(10) {
    width: 5% !important;
  }
  #table_row td p{
    margin-bottom: 0rem !important;
  }
  @media (min-width: 320px) and (max-width:680px){
    .style-action, .tooltip{
      z-index: 1 !important;
    }
    #table_row td p{
      margin-bottom: 1rem !important;
    }
    #table_row td #statusHeading{
      margin-bottom: -0.4rem !important;
    }
    #td_span,#responsiveStatus{
      display: block !important;
    }
    #responsive_status{
      display: block !important;
   
     
    }
    #responsive_status span{
      color: white;
      font-size: 10px;
      background: #fc5d60;
      height: 21px;
      width: auto;
      padding: 9% 9% !important;
      margin-top: 4px !important;
  
    }
    #support_table_header,#status{
      display: none;
    }
    #dataTable,#table_body{
      display: block !important;
      width: 100% !important;
    }
    #table_body{
      padding: 0% 2.5%
    }
    #table_row{
      display: flex;
      /* border-top: 1px solid lightgray; */
      flex-wrap: wrap;
      border: 1px solid lightgrey;
      border-radius: 0.3rem;
      margin-bottom: 10px;
    }
    #table_row td{
      padding-left: 2% !important;
      font-weight: 500px;
      border-top: 0px !important;
      padding-right: 0px;
      padding-bottom: 0px;
    }
      table tr td:nth-child(1) {
      width: 40% !important;
      order: 1;
      font-size: 10px !important;
    }
    
    table tr td:nth-child(2) {
      width: 26% !important;
      order: 2;
      font-size: 10px !important;
    }

    table tr td:nth-child(3) {
      width: 23% !important;
      order: 4;
      font-size: 10px !important;
      margin-top: -7% !important;
      /* padding-bottom: 12px !important; */
    }

    table tr td:nth-child(4) {
      width: 25% !important;
      order: 5;
      font-size: 10px !important;
      margin-top: -7% !important;
      /* padding-bottom: 12px !important; */
      /* z-index: 1; */
    }

    table tr td:nth-child(5) {
      width: 25% !important;
      order: 6;
      font-size: 10px !important;
      margin-top: -7% !important;
      /* padding-bottom: 12px !important; */
    }

    table tr td:nth-child(6) {
      width: 25% !important;
      order: 7;
      font-size: 10px !important;
      margin-top: -7% !important;
      /* padding-bottom: 12px !important; */
    }

    table tr td:nth-child(7) {
      width: 22% !important;
      font-size: 8px !important;
      padding-right: 0px;
      text-align: center;
      order: 3;
    }

    table tr td:nth-child(8) {
      width: 5% !important;
      order: 3;
      font-size: 10px !important;
      padding-left: 0% !important;
      padding-top: 0% !important;
      padding-bottom: 5% !important ;
    }
    table tr td:nth-child(2) p, table tr td:nth-child(4) p{
      overflow:hidden; 
      white-space:nowrap; 
      text-overflow: ellipsis;
    }
    #action_button{
      color:#6e737c; 
      transform: rotate(90deg);
      margin-top: 11px;
    }
     table tr td:not(:nth-child(1)) p{
      color: #62626e !important;
      font-weight: bold;
      overflow: hidden !important;
      white-space: nowrap !important;
      text-overflow: ellipsis !important;
     }
     table tr td:nth-child(1) p{
      color: #3571a1 !important;
      font-weight: bold;
      overflow: hidden !important;
      white-space: nowrap !important;
      text-overflow: ellipsis !important;
     }
     #font_size{
      font-size: 12px !important;
     }
     .pr-5, .px-5 {
          padding-right: 0.5rem !important;
      }
      .change_page a:hover {
        background-color: #ddd !important;
        color: black;
      }

      .change_page .previous {
        background-color: #f1f1f1;
        color: black;
      }

      .change_page .next {
        background-color: #04AA6D !important;
        color: white;
        margin-left: 4% !important;
      }
      .change_page a {
        text-decoration: none;
        display: inline-block;
        padding: 8px 16px;
      }
      .pagination{
        display: none !important;
      }
      .table{
        border-bottom: 0px !important; 
      }
      .border-top{
        border-top:0px !important;
      }
      .display_rows{
        display: none !important;;
      }
      .change_page{
        display: block !important;
        width: 57% !important;
      }
      .table-responsive{
        margin-top: 109px !important;
      }
      #statusHeading{
        color: #9a9aa1;
        margin-bottom: -1rem !important;
        padding-left: 14% !important;
      }
      #responsiveStatus .dropdown-item{
        margin-bottom: 0.1rem !important;
      }
      .btn:focus, .btn.focus{
        box-shadow: 0 0 0 0rem !important;
      }
      .loader_responsive{
        margin: 0rem 0.7rem;
        padding: 0.5rem 0.5rem 0.2rem 0.5rem;
        border: 1px solid lightgrey;
        border-radius: 0.3rem;
      }
  }
   @media (min-width: 427px) and (max-width:680px){
    #table_body{
      margin-top: 2% !important;
    }
        
   }  

  @media only screen and (min-width: 1280px) and (max-width: 1724px) {
    td {
      font-size: 12px;
    }

    table tr td:nth-child(1) {
      width: 18% !important;
    }

    table tr td:nth-child(2) {
      width: 18% !important;
    }

    table tr td:nth-child(3) {
      width: 18% !important;
    }

    table tr td:nth-child(4) {
      width: 11% !important;
    }

    table tr td:nth-child(5) {
      width: 13% !important;
    }

    table tr td:nth-child(6) {
      width: 10% !important;
    }

    table tr td:nth-child(7) {
      width: 14% !important;
    }

    table tr td:nth-child(8) {
      width: 1% !important;
    }
  }
</style>